import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'proxy-text',
  templateUrl: './proxy-text.component.html',
  styleUrls: ['./proxy-text.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class ProxyTextComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
  ) { }

  @Input() text: string = undefined;
  done;

  ngOnChanges(event) {
    this.done = this._sanitizer.bypassSecurityTrustHtml(event.text.currentValue);
  }
  ngOnInit() {
  }

}
